import { Constants } from '@/cfg/constants';

function partValue(parts, type) {
  const part = parts.find((p) => p.type === type);
  return part ? part.value : '';
}

// "Session began 5 August 2026 at 22:55 BST" (uk) / "Session began Aug 5, 2026 at 10:55 PM EDT" (global)
export function formatSessionBeganLabel(dateInput) {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isUk = Constants.REGION === 'uk';
  const { language } = Constants.REGION_CONFIG;

  const parts = new Intl.DateTimeFormat(language, {
    day: 'numeric',
    month: isUk ? 'long' : 'short',
    year: 'numeric',
    hour: isUk ? '2-digit' : 'numeric',
    minute: '2-digit',
    hour12: !isUk,
    userTimeZone,
    timeZoneName: 'short',
  }).formatToParts(date);

  const day = partValue(parts, 'day');
  const month = partValue(parts, 'month');
  const year = partValue(parts, 'year');
  const hour = partValue(parts, 'hour');
  const minute = partValue(parts, 'minute');
  const dayPeriod = partValue(parts, 'dayPeriod');
  const zone = partValue(parts, 'timeZoneName');

  const datePart = isUk ? `${day} ${month} ${year}` : `${month} ${day}, ${year}`;
  const timePart = isUk ? `${hour}:${minute}` : `${hour}:${minute} ${dayPeriod}`;

  return `Session began ${datePart} at ${timePart} ${zone}`;
}

// Short list-item date, e.g. "Wed, Aug 5" (global) / "Wed 5 Aug" (uk)
export function formatTranscriptListDate(dateInput) {
  const date = new Date(dateInput);
  const { language, timeZone } = Constants.REGION_CONFIG;

  return date.toLocaleDateString(language, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone,
  });
}

// Month/year group label, e.g. "August 2026"
export function formatTranscriptMonthLabel(monthKey) {
  const [year, month] = monthKey.split('-');
  const date = new Date(`${year}-${month}-15`);
  const { language } = Constants.REGION_CONFIG;

  return date.toLocaleDateString(language, {
    month: 'long',
    year: 'numeric',
  });
}

// Short date only, e.g. "05/08/2026" (uk) / "08/05/2026" (global)
export function formatTranscriptShortDate(dateInput) {
  const date = new Date(dateInput);
  const { language, timeZone } = Constants.REGION_CONFIG;

  return date.toLocaleDateString(language, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone,
  });
}
